export enum RuleUpdateErrorType {
  INCORRECT_PARENT_RULE_ARRAY = 'INCORRECT_PARENT_RULE_ARRAY',
  NO_GROUPABLE_PREVIOUS_ITEM = 'NO_GROUPABLE_PREVIOUS_ITEM',
  NOT_GROUPABLE_SCOPE = 'NOT_GROUPABLE_SCOPE',
  NOT_UNGROUPABLE_SCOPE = 'NOT_UNGROUPABLE_SCOPE',
  INCORRECT_PATH = 'INCORRECT_PATH',
}

export enum RuleUpdateOperationType {
  UPDATED_ALL_BOOL_OPERATORS_SAME_LEVEL = 'UPDATED_ALL_BOOL_OPERATORS_SAME_LEVEL',
  AUTO_CORRECTED_AMBIGUOUS_OPERATOR_RULE = 'AUTO_CORRECTED_AMBIGUOUS_OPERATOR_RULE',
  CANCEL_PENDING_RULE_GROUP = 'CANCEL_PENDING_RULE_GROUP',
}

export const supportedUndoTypes = new Set([
  RuleUpdateOperationType.UPDATED_ALL_BOOL_OPERATORS_SAME_LEVEL,
  RuleUpdateOperationType.AUTO_CORRECTED_AMBIGUOUS_OPERATOR_RULE,
]);
